import {useState} from 'react';

import createHttpRequest from 'shared/api/http';
import {HttpMethodType} from 'shared/model/types';
import {ApiUrls} from 'shared/config/model/urls';

import IBatchResult from './IBatchResult';

const POLLING_INTERVAL_MS = 1000;

export interface IBatchTriggerOptions {
    silent?: boolean,
}

const useBatchOperation = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [progress, setProgress] = useState(0);


    const trigger = async(
        path: string,
        method: HttpMethodType,
        data: object,
        // eslint-disable-next-line no-unused-vars
        onSuccess: (result: IBatchResult) => void,
        options: IBatchTriggerOptions = {},
    ) => {
        setIsLoading(true);
        setProgress(0);

        let operationId: string;
        try {
            const response = await createHttpRequest({
                path,
                method,
                data,
                ...(options.silent ? {silent: true} : {}),
            });
            operationId = response.data.operation_id;
        } catch (error) {
            setIsLoading(false);
            throw error;
        }

        void polling(operationId, onSuccess);
    };

    // eslint-disable-next-line no-unused-vars
    const polling = async(operationId: string, onSuccess: (result: IBatchResult) => void) => {
        let response;
        try {
            response = await createHttpRequest({
                path: ApiUrls.BATCH_CHECK(operationId),
                method: 'GET',
            });
        } catch {
            setIsLoading(false);
            return;
        }

        if (typeof response.data.progress === 'number') {
            setProgress(response.data.progress);
        }

        if (response.data.ready) {
            onSuccess(response.data);
            setIsLoading(false);
        }else {
            setTimeout(() => polling(operationId, onSuccess), POLLING_INTERVAL_MS);
        }
    };

    return { trigger, isLoading, progress };
};

export default useBatchOperation;
